export default "__VITE_ASSET__DjFey3Ig__"